/**
 * LoadingSkeleton — placeholder while report fetches (CR-0015).
 */
export default function LoadingSkeleton() {
  return (
    <div data-testid="report-loading" className="mx-4 mt-6 space-y-3">
      <div className="h-32 rounded-md bg-gray-100 animate-pulse" />
      <div className="h-20 rounded-md bg-gray-100 animate-pulse" />
      <div className="h-20 rounded-md bg-gray-100 animate-pulse" />
    </div>
  );
}
